import { render, staticRenderFns } from "./flowNodeCopyText.vue?vue&type=template&id=3402c389&scoped=true&"
import script from "./flowNodeCopyText.vue?vue&type=script&lang=js&"
export * from "./flowNodeCopyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3402c389",
  null
  
)

export default component.exports